import { IkeToken } from '@ikegps/core-api';
import { ImageButton } from '../../components/button/image.button';
import { Icon } from '../../components/icon';
import { MaterialIcon } from '../../components/icon/icons';
import { IMithrilComponent } from '../../components/mithril.component';
import { Spinner } from '../../components/spinner/spinner';
import { addStyles } from '../../components/theme';
import { T, Translate } from '../../i18n/index';
import { m } from '../../mithril';
import { Services } from '../../services';
import { CSS, Style } from './multi.list.search.style';

addStyles(Style);

export class MultiListSearch extends IMithrilComponent {
	get nodes() {
		//the filterbar is an IKE Analyze only feature
		if (!Services.Token.has(IkeToken.FEATURE_GROUP_IKE_ANALYZE)) {
			Services.MultiListSearch.filterState.clear();
			Services.MultiListSearch.inputfilterState.clear();
			return null;
		}

		const cancelButton = ImageButton.view(MaterialIcon.CLOSE, {
			className: CSS.clear,
			onclick: () => Services.MultiListSearch.reset(),
		});

		const icon = Services.MultiListSearch.filtering
			? Spinner.view(CSS.icon)
			: Icon.view(MaterialIcon.SEARCH, { className: CSS.icon });

		return m('div', { className: CSS.container }, [
			icon,
			m('input', {
				className: CSS.input,
				type: 'text',
				placeholder: Translate(T.FILTER),
				value: Services.MultiListSearch.inputfilterState.filter,
				oninput: (e) => this.onChange(e),
			}),
			Services.MultiListSearch.inputfilterState.hasFilter() ? cancelButton : null,
		]);
	}

	private onChange(e: Event) {
		Services.MultiListSearch.inputfilterState.setFilter((e.target as HTMLInputElement).value);
	}
}
